import { render, staticRenderFns } from "./BlogFour.vue?vue&type=template&id=1756821a&"
import script from "./BlogFour.vue?vue&type=script&lang=js&"
export * from "./BlogFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1756821a')) {
      api.createRecord('1756821a', component.options)
    } else {
      api.reload('1756821a', component.options)
    }
    module.hot.accept("./BlogFour.vue?vue&type=template&id=1756821a&", function () {
      api.rerender('1756821a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/blogs/BlogFour.vue"
export default component.exports